import { render, staticRenderFns } from "./Digipay.vue?vue&type=template&id=34958f91&scoped=true&"
import script from "./Digipay.vue?vue&type=script&lang=js&"
export * from "./Digipay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34958f91",
  null
  
)

export default component.exports